import * as actions from 'store/billing/financialAssistance/createApplication/actions';
import { createReducer } from '@reduxjs/toolkit';

import { switchAccountSuccess } from 'store/account/actions';
import { CompleteForm } from '../types';

const initialCompleteFormState: CompleteForm | {} = {};

const completeReducer = createReducer<CompleteForm | {}>(initialCompleteFormState, {
  [actions.SET_FA_FORM_5_COMPLETE]: (state, action) => action.payload,

  [actions.SET_FA_FORM_CLEAR]: () => initialCompleteFormState,

  [switchAccountSuccess.type]: () => initialCompleteFormState
});

export default completeReducer;
